import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dc3a7a6c&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=dc3a7a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_fa4cvkteopfvx2274rwhhr2idm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3a7a6c",
  null
  
)

export default component.exports